<footer class="footer app-footer">
    <div class="app-footer__brand">
        <span class="app-footer__mark">GM</span>
        <span>© {{ currentYear }} Grupo Mancheno</span>
    </div>

    <div class="app-footer__meta">
        <span>Desarrollado por <a href="https://sys-nova.com" target="_blank" rel="noopener">Sys-Nova</a></span>
        <span class="app-version-badge">{{ appVersion }}</span>
    </div>
</footer>
